import { Flex } from '@abyss/web/ui/Flex';
import { IconSymbol } from '@abyss/web/ui/IconSymbol';
import { Popover } from '@abyss/web/ui/Popover';
import { Text } from '@abyss/web/ui/Text';
import { find } from 'lodash';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { ConstantsLagoon } from '../../../common/ConstantsLagoon';
import { useLagoon } from '../../../hooks/useLagoon';
import { landingPopOverIcon } from '../../ConstantsStyles';

export const VirtualSpecialtyCareCostInfo = ({
  additionalStyles = {},
  isLandingPage = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const { t } = useTranslation();
  const uiMessaging = useLagoon('ui-messaging')();

  const costEstimatesContent = find(uiMessaging, {
    key: ConstantsLagoon.VIRTUAL_CARE.VIRTUAL_CARE_COST_ESTIMATE_MESSAGE,
  });

  const heading = t('VIRTUAL_SPECIALTY_CARE_SECTION.COST_ESTIMATE');
  return (
    <Flex
      alignItems="center"
      css={{
        gap: '16px',
        ...additionalStyles,
      }}
    >
      <Text
        css={{
          color: 'black',
          fontFamily: 'UHC2020 Sans',
          fontSize: '14px',
          fontStyle: 'normal',
          fontWeight: 700,
          lineHeight: '18px',
          margin: 0,
        }}
      >
        {t('VIRTUAL_SPECIALTY_CARE_SECTION.YOU_PAY')}
      </Text>

      <Flex
        alignItems="center"
        css={{
          gap: '8px',
        }}
      >
        <Text
          css={{
            color: '$primary6',
            fontFamily: 'UHC2020 Sans',
            fontSize: isLandingPage ? '14px' : '16px',
            fontStyle: 'normal',
            fontWeight: 500,
            lineHeight: '18px',
            margin: 0,
          }}
        >
          {t('VIRTUAL_SPECIALTY_CARE_SECTION.VARIES')}
        </Text>

        <Popover
          content={costEstimatesContent?.message ?? ''}
          css={{
            'abyss-popover-content': {
              zIndex: '9',
            },
          }}
          data-auto-testid={'cost-info-icon'}
          data-testid={'cost-info-icon'}
          onOpenChange={() => setIsOpen(!isOpen)}
          open={isOpen}
          title={heading}
        >
          <IconSymbol
            css={landingPopOverIcon}
            data-auto-testid={'cost-info-icon'}
            data-testid={'cost-info-icon'}
            icon="info"
            onClick={() => setIsOpen(true)}
            size={16}
            variant="outlined"
          />
        </Popover>
      </Flex>
    </Flex>
  );
};
